var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13675f"
    },
    d: "M15.391,19.341L14,11l-1.39,8.341C11.653,19.842,11,20.845,11,22c0,1.657,1.343,3,3,3s3-1.343,3-3 C17,20.845,16.348,19.842,15.391,19.341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13675f"
    },
    d: "M14,3C6.268,3,0,9.268,0,17c0,2.059,0.444,4.014,1.242,5.773c0.544-0.312,1.147-0.605,1.8-0.875 C2.372,20.402,2,18.745,2,17C2,10.373,7.373,5,14,5s12,5.373,12,12c0,1.745-0.372,3.402-1.042,4.898 c0.653,0.27,1.256,0.562,1.8,0.875C27.557,21.014,28,19.059,28,17C28,9.268,21.732,3,14,3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#13675f"
    },
    d: "M3.828,21.377l-0.617-1.901l3.805-1.235l0.617,1.902L3.828,21.377z M9.063,11.929l-2.35-3.236 l1.62-1.176l2.35,3.237L9.063,11.929z M13,6h2v4h-2V6z M7.015,15.801l-3.804-1.236l0.619-1.902l3.804,1.236L7.015,15.801z  M20.983,15.8l-0.617-1.902l3.806-1.235l0.617,1.901L20.983,15.8z M17.316,10.753l2.352-3.235l1.619,1.176l-2.351,3.236 L17.316,10.753z M24.172,21.377l-3.805-1.235l0.617-1.901l3.805,1.235L24.172,21.377z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.a339dfd2713dfc834f61f2960e15e318.svg";
export { ForwardRef as ReactComponent };